module.exports = __webpack_public_path__ + "static/media/bag_dark.1b5d095b.svg";